var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageCurrent)?_c('img',{staticClass:"img-icon",attrs:{"src":_vm.imageCurrent}}):_c('img',{staticClass:"img-icon",attrs:{"width":"20","src":require("../assets/user.png"),"alt":"default"}})
}
var staticRenderFns = []

export { render, staticRenderFns }